export default __webpack_public_path__ + "assets/fonts/cd1c13d66c3c66a9401f18a14cab01c8.woff";